import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import type { EntitlementsContext } from '../../api/web-api'

export interface EntitlementsState {
    organizationId: string
    entitlementsMask: number
    bypassEntitlementEnforcement: boolean
    expiresAtUtc: string
    schemaVersion: number
    isHydrated: boolean
}

export const initialEntitlementsState: EntitlementsState = {
    organizationId: '',
    entitlementsMask: 0,
    bypassEntitlementEnforcement: false,
    expiresAtUtc: '',
    schemaVersion: 0,
    isHydrated: false,
}

// Normalize backend entitlement context into the single Redux shape used across portals.
export const normalizeEntitlementsState = (
    entitlements?: Partial<EntitlementsContext> | null,
    organizationId?: string | null
): EntitlementsState => {
    if (!entitlements && !organizationId) {
        return initialEntitlementsState
    }

    return {
        organizationId: organizationId ?? entitlements?.organizationId ?? '',
        entitlementsMask: Number(entitlements?.entitlementsMask ?? 0),
        bypassEntitlementEnforcement: Boolean(entitlements?.bypassEntitlementEnforcement),
        expiresAtUtc: entitlements?.expiresAtUtc ?? '',
        schemaVersion: entitlements?.schemaVersion ?? 0,
        isHydrated: true,
    }
}

const entitlementsSlice = createSlice({
    name: 'entitlements',
    initialState: initialEntitlementsState,
    reducers: {
        setEntitlements: (_, action: PayloadAction<EntitlementsState>) => action.payload,
        clearEntitlements: () => initialEntitlementsState,
    },
})

export const { setEntitlements, clearEntitlements } = entitlementsSlice.actions

export default entitlementsSlice.reducer
